import 'react-responsive-modal/styles.css';
import './style/review.css';
import {BrowserRouter, Route, Routes} from "react-router-dom"
import Intervention from "./components/bean/Intervention";
import Site from "./components/bean/Site";
import Clients from "./components/lists/Clients"
import Client from "./components/bean/Client";
import Sites from "./components/lists/Sites";
import Interventions from "./components/lists/Interventions";
import Parameter from "./components/bean/Parameter";
import PrivateRoute from "./components/util/PrivateRoute";
import AuthPage from "./components/util/AuthPage";
import AdminCrud from "./components/admin/AdminCrud";
import Devis from "./components/bean/Devis";
import ErrorManager from "./utils/Error";
import IbatApi from "./utils/IbatApi";
import {ouvrirFluxNotifications} from "./utils/fluxNotifications";
import {SnackbarProvider} from "notistack";
import React, {useEffect, useState} from "react";
import SignInForm from "./components/forms/SignInForm";
import Supply from "./components/bean/Supply";
import TimeSheet from "./time-sheet/TimeSheet";
import Download from "./components/bean/Download";
import {NotificationContainer, NotificationManager} from 'react-notifications'
import Notifications from "./components/bean/Notifications";
import Modal from "react-responsive-modal";
import InteractionClient from "./components/bean/InteractionClient";
import Quotations from "./components/lists/Quotations";
import Quotation from "./quotation/Quotation";
import Navbar from "./components/util/Navbar";
import TrackFile from "./components/bean/TrackFile";
import RoofAnalyserIa from "./components/bean/RoofAnalyserIa";


function App() {
    const api = new IbatApi()

    const myUsername = api.getTokenData()?.username
    const [notificationNumber, setNotificationNumber] = useState()
    const [token, setToken] = useState("")
    const [logo] = useState(api.getLogoCookie)
    const [style] = useState(api.getStyleCookie() ?? "") //(window.location.href.split("//")[1].split(".")[0].includes("localhost") ? "" : window.location.href.split("//")[1].split(".")[0]+"-"))
    const [showInteractionClient, setShowInteractionClient] = useState(false);
    const [ongletVisible, setOngletVisible] = useState(!document.hidden)

    useEffect(() => {
        refreshToken()
        import(`./style/variable/${style}variable.css`)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])
    useEffect(()=>{
        handleNotificationNumberUpdate()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notificationNumber])

    const refreshToken = () => {
        setToken(api.getToken())
        // getCompanyFrontData()
    }
    /*function getCompanyFrontData(){
      if (token){
        api.getCompany().then(resp=>{
          let style1 = resp.frontStyle
          if (style1 !== style || !api.getStyleCookie()){
            api.setStyleCookie(style1)
          }
          api.getFile(resp.logo).then(r=>{
            api.setLogoCookie(r.b64)
            setLogo(r.url)
          })
          import(`./style/variable/${style}variable.css`)
        })
      }
    }
    function getDefaultStatus() {
        let tokenData = api.getTokenData();
        if (!tokenData) {
            return
        }
        let role = 1
        switch (role) {
            case "GESTIONNAIRE" :
                return {defaultFilter: ""};
            case "TECHNICALMANAGER" :
                return {defaultFilter: ""};
            case "BILLMANAGER":
                return {defaultFilter: ""}
            default :
                return {defaultFilter: ""}
        }
    }*/

    const handleDeconnexion = () => {
        api.deconexion()
    }
    /*function getNotificationsNumber(){
        api.getNotificationsNumber()
            .then(resp => {
                setNotificationNumber(resp < 100 ? resp : "99+")
            })
    }*/
    function handleNotificationNumberUpdate(){
        let element = document.getElementById("notificationNumber")
        if (!element){
            return
        }
        if (notificationNumber && notificationNumber!==0){
            element.style.visibility = "visible"
            element.innerHTML = notificationNumber
        } else {
            element.style.visibility = "hidden"
        }
    }

    /*let onConnected = () => {
        getNotificationsNumber()

    }*/
    let onMessageReceived = (msg) => {
        // Les évènements sans cible — l'accusé de lecture, par exemple — n'ont
        // rien à afficher.
        if (!msg.target || window.location.pathname === "/notifications"){
            return;
        }
        NotificationManager.info(msg.message.replace("\n", "\r\n"), msg.from?.name, 20000, ()=>{
            if (msg.target.includes("interactionClient")){
                let vars = {}
                let filter = msg.target.split("?")[1].split("&")
                for (const filterKey in filter) {
                    let values = filter[filterKey].split("=")
                    vars[values[0].replace("interventionId", "id")] = values[1]
                }
                setShowInteractionClient(vars)
            }
            else {
                window.open(`/${msg.target}`)
            }
        });
    }

    // Le flux n'est ouvert que sur l'onglet au premier plan.
    //
    // Chrome plafonne un groupe de sockets à six, et un flux SSE en tient une
    // tant qu'il vit. Un utilisateur à vingt-cinq onglets saturait donc le
    // groupe avec ses seuls flux de notifications, et toute requête ayant
    // besoin d'une socket neuve attendait qu'un onglet se ferme — jusqu'à cent
    // secondes relevées dans un netlog de production.
    useEffect(() => {
        const surVisibilite = () => setOngletVisible(!document.hidden)
        document.addEventListener("visibilitychange", surVisibilite)
        return () => document.removeEventListener("visibilitychange", surVisibilite)
    }, [])

    // Flux de notifications temps réel, en remplacement de SockJS et STOMP.
    //
    // Le flux ne va que du serveur vers le navigateur, l'URL tient lieu
    // d'abonnement, et le service ne sert que les notifications du porteur du
    // jeton — il n'y a plus de nom de sujet à choisir, donc plus moyen
    // d'écouter celles d'un autre.
    useEffect(() => {
        if (!token || !ongletVisible) {
            return
        }
        return ouvrirFluxNotifications(
            `${api.api_url}/notification-server/stream`,
            api.getToken(),
            onMessageReceived
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, ongletVisible])

    return (
        <div className={"grid myBody"}>
            {api.getToken()
                ?
                <Navbar logo={logo} myUsername={myUsername} handleDeconnexion={handleDeconnexion} notificationNumber={notificationNumber}/>
                :
                <div></div>
            }

            <ErrorManager>
                <SnackbarProvider maxSnack={3}>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={<AuthPage refreshToken={refreshToken} />}/>
                            <Route path="/subscribe" element={<SignInForm refreshToken={refreshToken} />}/>

                            <Route path={"/interventions/:id"} element={
                                <PrivateRoute>
                                    <Intervention />
                                </PrivateRoute>
                            }/>

                            <Route path={"/trackFile/:token"} element={
                                /*<PrivateRoute>
                                </PrivateRoute>*/
                                <TrackFile />
                            }/>
                            <Route path={"/interventions"} element={
                                <PrivateRoute>
                                    <Interventions />
                                </PrivateRoute>
                            }/>
                            <Route path={"/supplies"} element={
                                <PrivateRoute>
                                    <Supply />
                                </PrivateRoute>
                            }/>
                            <Route path={"/parameter"} element={
                                <PrivateRoute>
                                    <Parameter />
                                </PrivateRoute>
                            }/>
                            <Route path={"/admin"} element={
                                <PrivateRoute>
                                    <AdminCrud />
                                </PrivateRoute>
                            }/>

                            <Route path={"/devis/:id"} element={
                                <PrivateRoute>
                                    <Devis />
                                </PrivateRoute>
                            }/>
                            <Route path={"/times"} element={
                                <PrivateRoute>
                                    <TimeSheet />
                                </PrivateRoute>
                            }/>
                            <Route path={"/client/:id"} element={
                                <PrivateRoute>
                                    <Client />
                                </PrivateRoute>
                            }/>
                            <Route path={"/clients"} element={
                                <PrivateRoute>
                                    <Clients />
                                </PrivateRoute>
                            }/>
                            <Route path={"/site/:id"} element={
                                <PrivateRoute>
                                    <Site />
                                </PrivateRoute>
                            }/>
                            <Route path={"/sites"} element={
                                <PrivateRoute>
                                    <Sites />
                                </PrivateRoute>
                            }/>
                            <Route path={"/download-apk"} element={
                                <Download />
                            }/>
                            <Route path={"/roof-analyser"} element={
                                <RoofAnalyserIa />
                            }/>
                            <Route path={"/notifications"} element={
                                <PrivateRoute>
                                    <Notifications />
                                </PrivateRoute>
                            }/>
                            <Route path={"/quotation/:id"} element={
                                <PrivateRoute>
                                    <Quotation />
                                </PrivateRoute>
                            }/>
                            <Route path={"/quotations"} element={
                                <PrivateRoute>
                                    <Quotations />
                                </PrivateRoute>
                            }/>
                            <Route path={""} element={
                                <PrivateRoute>
                                    <Interventions />
                                </PrivateRoute>
                            }/>

                            <Route path="*" element={
                                <PrivateRoute>
                                    {/*<PageNotFound />*/}
                                    <Interventions />
                                </PrivateRoute>
                            } />

                            {/*<PrivateRoute path={"/interventions/:id"} component={Intervention}
                                            properties={getDefaultStatus()}/>
                              <PrivateRoute path={"/interventions"} component={Interventions}/>
                              <PrivateRoute path={"/supplies"} component={Supply} properties={getDefaultStatus()}/>
                              <PrivateRoute path={"/parameter"} component={Parameter}/>
                              <PrivateRoute path={"/admin"} component={AdminCrud}/>

                              <PrivateRoute path={"/devis/:id"} component={Devis}/>
                              <PrivateRoute path={"/times"} component={TimeSheet}/>

                              <PrivateRoute path={"/client/:id"} component={Client}/>
                              <PrivateRoute path={"/clients"} component={Clients}/>

                              <PrivateRoute path={"/site/:id"} component={Site}/>
                              <PrivateRoute path={"/sites"} component={Sites}/>

                              <PrivateRoute path={"/download-apk"} component={Download}/>

                              <PrivateRoute path={"/notifications"} component={Notifications}/>

                              <PrivateRoute path={"/quotation/:id"} component={Quotation}/>
                              <PrivateRoute path={"/quotations"} component={Quotations}/>

                              <PrivateRoute path={""} component={Interventions} properties={getDefaultStatus()}/>*/}

                        </Routes>
                    </BrowserRouter>

                    <Modal open={showInteractionClient} onClose={()=>setShowInteractionClient(false)}>
                        <InteractionClient {...showInteractionClient}/>
                    </Modal>
                </SnackbarProvider>
            </ErrorManager>
            <NotificationContainer />
        </div>
    );
}

export default App;
